import { render, staticRenderFns } from "./DSQuestionIcon.vue?vue&type=template&id=5ce17820&scoped=true&"
import script from "./DSQuestionIcon.vue?vue&type=script&lang=js&"
export * from "./DSQuestionIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce17820",
  null
  
)

export default component.exports